<template>
  <section class="data">
    <b-container>
      <header>
        <h2>Datos y estadísticas</h2>
      </header>
      <b-row>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-fCpJo" src="//datawrapper.dwcdn.net/fCpJo/3/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;"height="400"></iframe>
            <div class="description">
              <p><b>81,9%</b> en cuatro años acompañaron a 12.081 mujeres en sus procesos de aborto medicamentoso de un total de 14.752 que las contactaron. En el 2017 asesoraron a 161 mujeres para que accedan a la Interrupción Legal del Embarazo en servicios de salud y velaron por el cumplimiento del Protocolo de atención.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-yDdOV" src="//datawrapper.dwcdn.net/yDdOV/3/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="319"></iframe>
            <div class="description">
              <p><b>72,9%</b> de las mujeres que contactaron a las Socorristas en Red tienen entre 20 y 34 años. Esto denota que la mayoría de las mujeres que abortaron con medicación y fueron acompañadas son de edades en que “socialmente” se supone que están preparadas para ser madres.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-XlGbb" src="//datawrapper.dwcdn.net/XlGbb/2/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>62,2%</b> de las mujeres entrevistadas por las Socorristas en Red durante 2017 reconocieron que sufrieron algún tipo de violencia machista alguna vez en su vida. Pero <strong>sólo tres de cada diez</strong> efectuó la denuncia correspondiente.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-iPO9I" src="//datawrapper.dwcdn.net/iPO9I/1/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>5,6%</b> de casos de violencia obstétrica no es un dato menor. Que el aborto no sea legal permite escenas de violencia institucional a través de los centros de salud pública. Hay casos denunciados de legrados sin anestesia a mujeres que se sospecha que se han practicado un aborto.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-q7sw2" src="//datawrapper.dwcdn.net/q7sw2/1/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>42,5%</b> de las entrevistadas no tenía trabajo remunerado. La mitad de ellas reconoció que estaban buscando. Aquí no se cuantifica al trabajo vinculado al sostenimiento de la vida cotidiana, lo cual es habitualmente realizado por mujeres en el ámbito familiar.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-8j1IS" src="//datawrapper.dwcdn.net/8j1IS/1/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>29,9%</b> de las mujeres que contactaron a las Socorristas en Red no completaron el ciclo de formación requerido por la Ley de Educación Nacional. Esto es, hasta el nivel secundario. Y sólo una no transitó alguna vez por el sistema educativo.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-FrCCr" src="//datawrapper.dwcdn.net/FrCCr/1/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>57,2%</b> más de la mitad de las mujeres que solicitaron información sobre abortos medicamentosos tenían hijos. Esto hecha por tierra el discurso hegemónico que señala que las mujeres que abortan lo hacen porque no son madres y son tildadas de egoístas o irresponsables.</p>
            </div>
          </article>
        </b-col>
        <b-col sm="12" md="6">
          <article>
            <iframe id="datawrapper-chart-2emW7" src="//datawrapper.dwcdn.net/2emW7/1/" scrolling="no" frameborder="0" allowtransparency="true" style="width: 0; min-width: 100% !important;" height="400"></iframe>
            <div class="description">
              <p><b>43,4%</b> como en todas las decisiones importantes en nuestras vidas, rara vez hay una razón única. En este caso, una gran mayoría justificó la decisión de abortar en cuestiones relacionadas con la maternidad. O porque no era el momento o porque no querían volver a ser madres.</p>
            </div>
          </article>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>

export default {

  data () {
    return {
      test: 'Hola data'
    }
  },
  mounted () {
    // if("undefined"==typeof window.datawrapper)window.datawrapper={};window.datawrapper["fCpJo"]={},window.datawrapper["fCpJo"].embedDeltas={"100":400,"200":400,"300":400,"400":400,"500":400,"700":400,"800":400,"900":400,"1000":400},window.datawrapper["fCpJo"].iframe=document.getElementById("datawrapper-chart-fCpJo"),window.datawrapper["fCpJo"].iframe.style.height=window.datawrapper["fCpJo"].embedDeltas[Math.min(1e3,Math.max(100*Math.floor(window.datawrapper["fCpJo"].iframe.offsetWidth/100),100))]+"px",window.addEventListener("message",function(a){if("undefined"!=typeof a.data["datawrapper-height"])for(var b in a.data["datawrapper-height"])if("fCpJo"==b)window.datawrapper["fCpJo"].iframe.style.height=a.data["datawrapper-height"][b]+"px"});
  },
  beforeRouteEnter (to, from, next) {
    if (from.name != null) {
      window.scrollTo({
        top: Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 32,
        left: 0,
        behavior: 'smooth'
      })
    }
    next()
  }

}
</script>



// WEBPACK FOOTER //
// src/views/Data.vue